import { BorderBox } from "@/components/atoms/BorderBox";
import { QuestionFieldOptionsChangeProps } from ".";
import { OldNewValueChange } from "../OldNewValueChange";
import { ListTodo } from "lucide-react";

export function QuestionWasEditedChange({ context }: QuestionFieldOptionsChangeProps) {
    return (
        <BorderBox size={"sm"} className="flex flex-col items-start" >
            <h4 className="font-semibold flex gap-1 items-center"><ListTodo size="16"/>Question properties will change</h4>
            <div className="flex flex-col w-full gap-2">
                {context.changedProperties && context.changedProperties.length > 0 && context.changedProperties.map((changedProperty) => 
                    <OldNewValueChange
                        key={changedProperty.property}
                        valueName={`${changedProperty.property}`}
                        label={`Property "${changedProperty.property}" will change`}
                        oldLabel="From instance"
                        oldValue={changedProperty.instanceValue as string ?? '<empty>'}
                        newLabel="To template"
                        newValue={changedProperty.templateValue as string ?? '<empty>'}
                    />
                )}
            </div>
        </BorderBox>
    )
}